import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Mobile slide-down menu used by Navbar.
 * Extracted from Navbar.jsx for readability and easier maintenance.
 */
const NavbarMobileMenu = ({
  isOpen,
  onClose,
  services,
  scrollToHash,
  onContactClick,
}) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="fixed inset-0 z-40 mobile-menu pt-24 overflow-y-auto"
        data-testid="mobile-menu"
        data-dark
      >
        <div className="flex flex-col p-6">
          {/* Home */}
          <Link
            to="/"
            onClick={onClose}
            className="block py-3 text-xl text-gray-300 hover:text-white transition-colors border-b border-white/10 mb-4"
          >
            Home
          </Link>

          {/* Services */}
          <div className="mb-6">
            <p className="text-xs text-gray-500 uppercase tracking-wider mb-3">Services</p>
            <div className="space-y-2">
              {services.map((service) => (
                <Link
                  key={service.href}
                  to={service.href}
                  onClick={onClose}
                  className="block py-2 text-gray-300 hover:text-white transition-colors"
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 space-y-4">
            <button
              onClick={() => scrollToHash('#calculator')}
              className="block w-full text-left py-2 text-xl text-gray-300 hover:text-white transition-colors"
            >
              Pricing
            </button>

            {/* Mobile Resources */}
            <div className="py-2">
              <p className="text-xl text-gray-300 mb-2">Resources</p>
              <div className="ml-4 space-y-2">
                <Link to="/blog" onClick={onClose} className="block text-sm text-gray-400 hover:text-white transition-colors py-1">Blog</Link>
                <Link to="/case-studies" onClick={onClose} className="block text-sm text-gray-400 hover:text-white transition-colors py-1">Case Studies</Link>
                <Link to="/roi-calculator" onClick={onClose} className="block text-sm text-gray-400 hover:text-white transition-colors py-1">ROI Calculator</Link>
                <Link to="/cybersecurity-assessment" onClick={onClose} className="block text-sm text-gray-400 hover:text-white transition-colors py-1">Cybersecurity Assessment</Link>
                <Link to="/industries" onClick={onClose} className="block text-sm text-gray-400 hover:text-white transition-colors py-1">Industries</Link>
              </div>
            </div>

            <Link
              to="/contact-us"
              onClick={onClose}
              className="block py-2 text-xl text-gray-300 hover:text-white transition-colors"
            >
              Contact
            </Link>
          </div>

          <Button
            onClick={onContactClick}
            className="btn-primary-new px-8 py-6 rounded-none font-medium mt-8"
          >
            Get Protected
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default NavbarMobileMenu;
